<template>
  <div
    class="home"
    id="inicio"
    :style="`background-image: url(${require('@/assets/background-circles.svg')})`"
  >
    <Hero
      :surtitle="hero.surtitle"
      :title="hero.title"
      :description="hero.description"
      :cta="hero.cta"
      :background="hero.background"
    />
    <About />
    <Team />
    <Services />
    <Projects />
    <News />
    <Newsletter />
    <Contact />
  </div>
</template>

<script>
import Hero from "@/sections/Hero.vue";
import About from "@/sections/About.vue";
import Team from "@/sections/Team.vue";
import Services from "@/sections/Services.vue";
import Projects from "@/sections/Projects.vue";
import News from "@/sections/News.vue";
import Newsletter from "@/sections/Newsletter.vue";
import Contact from "@/sections/Contact.vue";

export default {
  name: "home",
  components: {
    Hero,
    About,
    Team,
    Services,
    Projects,
    News,
    Newsletter,
    Contact
  },
  data() {
    return {
      hero: {
        // surtitle: "Pilay Futura",
        // title: "Diseño Funcional",
        description:
          "Creamos espacios que combinan decisiones estéticas, técnicas, funcionales, económicas y legales, logrando un equilibrio armónico que permita el desarrollo de la actividad humana, proyectando a la persona y sus metas.",
        // cta: "Ver proyecto",
        background: require("@/assets/hero-background2.jpg")
      }
    };
  }
};
</script>

<style scoped lang="sass">
.home
  background-repeat: no-repeat
  background-size: 150%
  background-position: center 90vh
</style>
